import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past roughly the hero section (e.g., 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToMoney = () => {
    document.getElementById('money-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-171">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed top-0 left-0 right-0 z-40 bg-cream/90 backdrop-blur-md border-b border-sand shadow-sm py-3 px-4 flex justify-center" data-id="element-172">
          <button onClick={scrollToMoney} className="w-full max-w-md bg-terracotta hover:bg-terracotta-dark text-white font-semibold text-xs md:text-sm py-2.5 px-5 rounded-full shadow-md transition-colors" data-id="element-173">
            Reset My Nervous System Now
          </button>
        </motion.div>}
    </AnimatePresence>;
}